module.exports = __webpack_public_path__ + "img/selected7-min.d50c5f46.png";